module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#video",
      toString: function () {
        return this.url;
      }
    }